import type { LucideIcon } from 'lucide-react';

export default function StatCard({
  icon: Icon,
  label,
  value,
  hint,
}: {
  icon: LucideIcon;
  label: string;
  value: string | number;
  hint?: string;
}): JSX.Element {
  return (
    <div className="card">
      <div className="flex items-center gap-2 text-slate-500">
        <Icon size={18} className="text-brand-600" />
        <span className="text-sm">{label}</span>
      </div>
      <p className="mt-2 text-3xl font-bold">{value}</p>
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </div>
  );
}
